module.exports = __webpack_public_path__ + "media/scholarships/wisenheimer-new_@2x-308abbe9.png";